/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Ladda = require('ladda');
var Syphon = require('backbone.syphon');

var AddressView = require('common/views/AddressView');
var BreadcrumbView = require('common/views/BreadcrumbView');

var SecInvInqHeaderBarView = require('./SecInvInqHeaderBarView');
var SubmitInvInqComplainant = require('../services/SubmitInvInqComplainant');

var tmplSecInvInqComplainantEditView = require('../templates/SecInvInqComplainantEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecInvInqComplainantEditView,

  className: 'sec-inv-inq-complainant-edit-view container-fluid',

  ui: {
    addressForm: '.address-form-container',
    headerBar: '.header-bar-container',
    breadcrumb: '.breadcrumb-container',
    complainantForm: '.complainant-form',
    submit: '.submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    addressForm: '@ui.addressForm'
  },

  events: { 'click @ui.submit': 'onClickSubmit' },

  onBeforeShow: function() {
    var complainant = this.model.get('complainant') || {};
    var identifiers = this.model.get('identifiers') || {};
    var invInqId = this.model.get('invInqId');

    var category = identifiers.category;
    var objectId = identifiers.objectId;
    var objectLicenseId = identifiers.objectLicenseId;
    var caseNumber = identifiers.caseNumber;

    var breadcrumbs = [
      {
        link: '#sec/dashboard',
        text: 'Home'
      }
    ];

    if (identifiers.isOrganization === '1') {
      breadcrumbs.push({
        link: '#sec/organization/' + objectId + '/dashboard',
        text: identifiers.applicantLegalName
      });
      if (objectLicenseId) {
        breadcrumbs.push({
          link: '#sec/organization/' + objectId + '/license/' + objectLicenseId + '/dashboard',
          text: identifiers.licenseType
        });
      }
    } else {
      breadcrumbs.push({
        link: '#sec/individual/' + objectId + '/dashboard',
        text: identifiers.applicantLegalName
      });
      if (objectLicenseId) {
        breadcrumbs.push({
          link: '#sec/individual/' + objectId + '/license/' + objectLicenseId + '/dashboard',
          text: identifiers.licenseType
        });
      }
    }

    breadcrumbs = breadcrumbs.concat([
      {
        link: '#sec/investigation-inquiry/' + invInqId + '/dashboard',
        text: category + ' (' + caseNumber + ')'
      },
      {
        text: 'Complainant'
      }
    ]);

    this.showChildView(
      'headerBar',
      new SecInvInqHeaderBarView({
        model: new Backbone.Model(identifiers),
        isLicenseInvInq: !!identifiers.objectLicenseId
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: breadcrumbs
      })
    );

    this.addressForm = new AddressView({
      model: new Backbone.Model(complainant),
      horizontal: true,
      isRequired: false,
      startingCountry: complainant.country,
      startingPostalCode: complainant.postalCode,
      startingCounty: complainant.county
    });

    this.showChildView('addressForm', this.addressForm);
    Syphon.deserialize(this, complainant);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.invInqId = this.model.get('invInqId');
    formData.complainantId = this.model.get('complainantId');
    return formData;
  },

  validate: function() {
    return this.ui.complainantForm.parsley().whenValidate();
  },

  onClickSubmit: function(event) {
    event.preventDefault();
    var self = this;
    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      var formData = self.getFormData();
      SubmitInvInqComplainant(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:sc:investigation-inquiry-dashboard', self.model.get('invInqId'));
        })
        .fail(function() {
          l.stop();
        });
    });
  }
});
